/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */

import Card from "@mui/material/Card";
// Material Dashboard 2 React components
import { Stack, Switch, Typography } from "@mui/material";
import LoadingModal from "components/LoadingModel/loadingModal";
import MDBox from "components/MDBox";
import MDProgress from "components/MDProgress";
import MDTypography from "components/MDTypography";
import { useMaterialUIController } from "context";
import DataTable from "examples/Tables/DataTable";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { getDasboardSuperAdminGridData } from "utils/superAdminApi";

function Projects() {
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;

  const columns = [
    {
      Header: "Business User Name",
      accessor: "businessUserName",
      textAlign: "center",
    },
    {
      Header: "Customers (Count)",
      accessor: "customersCount",
      align: "center",
    },
    { Header: "Invoices (Count)", accessor: "invoicesCount", align: "center" },
    {
      Header: "Invoices Paid/Unpaid",
      accessor: "completedPaidPercentage",
      Cell: ({ row }) => {
        const completion = row.original.completedPaidPercentage;
        return (
          <MDBox
            width="8rem"
            textAlign="left"
            style={{ position: "relative" }}
            onMouseEnter={(e) => {
              e.currentTarget.querySelector(
                ".percentage-text"
              ).style.opacity = 1;
            }}
            onMouseLeave={(e) => {
              e.currentTarget.querySelector(
                ".percentage-text"
              ).style.opacity = 0;
            }}
          >
            <MDProgress
              value={completion}
              color="success"
              sx={{ backgroundColor: "#db5b14" }}
              variant="gradient"
              label={false}
            />
            <span
              style={{
                position: "absolute",
                top: 0,

                left: 10,
                width: "100%",
                height: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                opacity: 0,
                transition: "opacity 0.10s",
              }}
              className="percentage-text"
            >
              {completion}%
            </span>
          </MDBox>
        );
      },
    },
  ];

  const [loading, setLoading] = useState(false);
  const [rows, setRows] = useState([]);
  const [isMostActive, setIsMostActive] = useState(false);
  const dispatch = useDispatch();
  const [values, setValues] = useState({
    mostActive: "",
  });

  const handleToggleChange = () => {
    setIsMostActive((prevIsMostActive) => !prevIsMostActive);
  };

  useEffect(() => {
    fetchDasboardSuperAdminGridData();
  }, [isMostActive]);

  const fetchDasboardSuperAdminGridData = async () => {
    values.mostActive = isMostActive;
    getDasboardSuperAdminGridData(
      values,
      (data) => {
        if (data.Result_Output.length > 0) {
          setRows(data.Result_Output);
        }
      },
      dispatch
    );
  };

  return (
    <Card>
      <MDBox
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        px={3}
        pt={3}
      >
        <MDBox>
          <MDTypography variant="h6" gutterBottom>
            Business Users
          </MDTypography>
        </MDBox>
      </MDBox>
      <MDBox
        display="flex"
        justifyContent="end"
        alignItems="center"
        px={3}
        pb={3}
      >
        <Stack direction="row" spacing={2} alignItems="center">
          <Typography
            style={
              darkMode
                ? { color: "white", fontSize: "14px" }
                : { color: "black", fontSize: "14px" }
            }
          >
            Most Recent
          </Typography>
          <Switch
            checked={isMostActive}
            onChange={handleToggleChange}
            inputProps={{ "aria-label": "toggle" }}
          />
          <Typography
            style={
              darkMode
                ? { color: "white", fontSize: "14px" }
                : { color: "black", fontSize: "14px" }
            }
          >
            Most Active
          </Typography>
        </Stack>
      </MDBox>
      {!isMostActive && (
        <MDBox mt={-8.1}>
          <DataTable
            table={{ columns, rows }}
            showTotalEntries={false}
            isSorted={false}
            noEndBorder
            entriesPerPage={false}
          />
        </MDBox>
      )}
      {isMostActive && (
        <MDBox mt={-7}>
          <DataTable
            table={{ columns, rows }}
            showTotalEntries={false}
            isSorted={false}
            noEndBorder
            entriesPerPage={false}
          />
        </MDBox>
      )}
      <LoadingModal loading={loading} />
    </Card>
  );
}

export default Projects;
